export default "__VITE_ASSET__7p8vj2JF__"